import { gql } from '@apollo/client';

export const SEARCH_INS_BY_TRAITS = gql`
  mutation SearchInsByTraits($record: GqlSearchInsByTraitsInput!) {
    insi {
      searchInsByTraits(record: $record) {
        ok
        error {
          code
          message
          params
        }
        result {
          code
          candidates {
            ins {
              value
              type
              oid
            }
            tiq {
              nomNaissance
              listePrenom
              sexe
              dateNaissance
              lieuNaissance
            }
            historicalIns {
              value
              type
              oid
              periodStart
              periodEnd
            }
          }
          message
          existingPatientId
        }
      }
    }
  }
`;
